import React, { useRef, useEffect } from 'react';

const LANGUAGES = [
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'python', label: 'Python' },
  { value: 'html', label: 'HTML' },
  { value: 'css', label: 'CSS' },
  { value: 'json', label: 'JSON' },
  { value: 'sql', label: 'SQL' },
  { value: 'bash', label: 'Bash' },
  { value: 'markdown', label: 'Markdown' },
  { value: 'plain', label: 'Plain Text' }
];

const CodeBlock = ({ block, isActive, onChange }) => {
  const textareaRef = useRef(null);
  const { code = '', language = 'javascript' } = block.content || {};

  useEffect(() => {
    if (isActive && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isActive]);

  const handleKeyDown = (e) => {
    // Allow Tab key for indentation
    if (e.key === 'Tab') {
      e.preventDefault();
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      const newValue = code.substring(0, start) + '  ' + code.substring(end);
      onChange({ code: newValue });
      
      // Set cursor position after tab
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.selectionStart = textareaRef.current.selectionEnd = start + 2;
        }
      }, 0);
    }
  };

  return (
    <div className="code-block bg-gray-900 rounded-lg overflow-hidden">
      {/* Language selector */}
      <div className="flex items-center justify-between px-4 py-2 bg-gray-800 border-b border-gray-700">
        <select
          value={language}
          onChange={(e) => onChange({ language: e.target.value })}
          className="bg-gray-700 text-gray-300 text-sm px-2 py-1 rounded border border-gray-600 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          {LANGUAGES.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
        <span className="text-xs text-gray-500">Press Tab for indent</span>
      </div>

      {/* Code textarea */}
      <div className="p-4">
        <textarea
          ref={textareaRef}
          value={code}
          onChange={(e) => onChange({ code: e.target.value })}
          onKeyDown={handleKeyDown}
          placeholder="// Enter your code here..."
          className="w-full bg-transparent border-none outline-none resize-none font-mono text-sm text-gray-100 leading-relaxed min-h-[100px]"
          spellCheck={false}
          rows={5}
        />
      </div>
    </div>
  );
};

export default CodeBlock;
